/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as actions from './actions';
import * as api from './api';

export { actions, api };

export const ROUTE_PREFIX = '/activitypass';

export const MAX_PASSES_IN_CART = 10; // The maximum number of passes that can be in the cart (or in Order Details).

export const VehicleTypes = {
    'personal-vehicle': 'Personal Vehicle',
    'rental-vehicle': 'Rental Vehicle',
    'no-vehicle': 'No Vehicle',
    camper: 'Camper',
};

export const WatercraftTypes = {
    'motorized-boat': 'Motorized Boat',
    'non-motorized-boat': 'Non-Motorized Boat',
    'rental-boat': 'Rental Boat',
    'no-boat': 'No Boat',
};

export const Durations = {
    annual: {
        name: 'Annual',
        validLength: '12 Months',
        days: 365,
        endEndOfMonth: true,
    },
    '12-month': {
        name: 'Twelve Month',
        validLength: '12 Months',
        days: 365,
        endEndOfMonth: false,
    },
    semiannual: {
        name: 'Semiannual',
        validLength: '6 Months',
        days: 180,
        endEndOfMonth: true,
    },
    '6-month': {
        name: 'Six Month',
        validLength: '6 Months',
        days: 180,
        endEndOfMonth: false,
    },
    segment: {
        name: 'Segment',
        validLength: 'Flexible',
        days: -1,
        endEndOfMonth: false,
    },
    seasonal: {
        name: 'Seasonal',
        validLength: 'Seasonal',
        days: -1,
        endEndOfMonth: false,
    },
    season: {
        name: 'Seasonal',
        validLength: 'Seasonal',
        days: -1,
        endEndOfMonth: false,
    },
    '14-day': {
        name: 'Fourteen Days',
        validLength: '14 Days',
        days: 14,
        endEndOfMonth: false,
    },
    '13-day': {
        name: 'Thirteen Days',
        validLength: '13 Days',
        days: 13,
        endEndOfMonth: false,
    },
    '12-day': {
        name: 'Twelve Days',
        validLength: '12 Days',
        days: 12,
        endEndOfMonth: false,
    },
    '11-day': {
        name: 'Eleven Days',
        validLength: '11 Days',
        days: 11,
        endEndOfMonth: false,
    },
    '10-day': {
        name: 'Ten Days',
        validLength: '10 Days',
        days: 10,
        endEndOfMonth: false,
    },
    '9-day': {
        name: 'Nine Days',
        validLength: '9 Days',
        days: 9,
        endEndOfMonth: false,
    },
    '8-day': {
        name: 'Eight Days',
        validLength: '8 Days',
        days: 8,
        endEndOfMonth: false,
    },
    '7-day': {
        name: 'Week',
        validLength: '7 Days',
        days: 7,
        endEndOfMonth: false,
    },
    '6-day': {
        name: 'Six Days',
        validLength: '6 Days',
        days: 6,
        endEndOfMonth: false,
    },
    '5-day': {
        name: 'Five Days',
        validLength: '5 Days',
        days: 5,
        endEndOfMonth: false,
    },
    '4-day': {
        name: 'Four Days',
        validLength: '4 Days',
        days: 4,
        endEndOfMonth: false,
    },
    '3-day': {
        name: 'Three Days',
        validLength: '3 Days',
        days: 3,
        endEndOfMonth: false,
    },
    '2-day': {
        name: 'Two Days',
        validLength: '2 Days',
        days: 2,
        endEndOfMonth: false,
    },
    '1-day': {
        name: 'One day',
        validLength: '1 Day',
        days: 1,
        endEndOfMonth: false,
    },
    '14-day-offline': {
        name: 'Fourteen Days Offline',
        validLength: '14 Days',
        days: 14,
        endEndOfMonth: false,
    },
    '13-day-offline': {
        name: 'Thirteen Days Offline',
        validLength: '13 Days',
        days: 13,
        endEndOfMonth: false,
    },
    '12-day-offline': {
        name: 'Twelve Days Offline',
        validLength: '12 Days',
        days: 12,
        endEndOfMonth: false,
    },
    '11-day-offline': {
        name: 'Eleven Days Offline',
        validLength: '11 Days',
        days: 11,
        endEndOfMonth: false,
    },
    '10-day-offline': {
        name: 'Ten Days Offline',
        validLength: '10 Days',
        days: 10,
        endEndOfMonth: false,
    },
    '9-day-offline': {
        name: 'Nine Days Offline',
        validLength: '9 Days',
        days: 9,
        endEndOfMonth: false,
    },
    '8-day-offline': {
        name: 'Eight Days Offline',
        validLength: '8 Days',
        days: 8,
        endEndOfMonth: false,
    },
    '7-day-offline': {
        name: 'Week Offline',
        validLength: '7 Days',
        days: 7,
        endEndOfMonth: false,
    },
    '6-day-offline': {
        name: 'Six Days Offline',
        validLength: '6 Days',
        days: 6,
        endEndOfMonth: false,
    },
    '5-day-offline': {
        name: 'Five Days Offline',
        validLength: '5 Days',
        days: 5,
        endEndOfMonth: false,
    },
    '4-day-offline': {
        name: 'Four Days Offline',
        validLength: '4 Days',
        days: 4,
        endEndOfMonth: false,
    },
    '3-day-offline': {
        name: 'Three Days Offline',
        validLength: '3 Days',
        days: 3,
        endEndOfMonth: false,
    },
    '2-day-offline': {
        name: 'Two Days Offline',
        validLength: '2 Days',
        days: 2,
        endEndOfMonth: false,
    },
    '1-day-offline': {
        name: 'One Day Offline',
        validLength: '1 Day',
        days: 1,
        endEndOfMonth: false,
    },
};

export const Features = [
    'accepted',
    'attendee-info',
    'day-segment',
    'discount',
    'equipment-info',
    'start-date',
];
export const Equipment = ['vehicle', 'watercraft'];

export const ReservationPointsOfSale = ['web', 'field'];
export const ReservationStatuses = ['pending', 'deleted', 'completed'];

export const ExpirationTypes = ['expired', 'refunded', 'voided'];

export default ROUTE_PREFIX;

// common date format strings
export const DATE_FORMAT_STANDARD = 'YYYY-MM-DD';
export const DATE_FORMAT_US_SLASHES = 'MM/DD/YYYY';

export const PRICE_MAGNITUDE = 100000;

export const MAX_GROUP_COUNT = 999;

export const INTERAGENCY_DISCOUNT_PASSES = [
    'Interagency Access Pass',
    'Interagency Annual Senior Pass',
    'Interagency Lifetime Senior Pass',
    'Golden Access Pass',
    'Golden Age Pass',
];

export const boatDescriptionRules = {
    'motorized-boat': 'optional',
    'no-boat': 'N/A',
    'non-motorized-boat': 'required',
    'rental-boat': 'N/A',
};

// inventory types
export const INVENTORY_CAMPING = 'CAMPING';
export const INVENTORY_PERMIT = 'PERMIT';
export const INVENTORY_VEHICLE_PERMIT = 'VEHICLE_PERMIT';
export const INVENTORY_TICKET = 'TICKET';
export const INVENTORY_TIMED_ENTRY = 'TIMED_ENTRY';
export const INVENTORY_LOTTERY_TICKET = 'LOTTERY_TICKET';
export const INVENTORY_LOTTERY_PERMIT = 'LOTTERY_PERMIT';
export const INVENTORY_PASS = 'PASS';
export const INVENTORY_PARKPASS = 'PARKPASS';
export const INVENTORY_ACTIVITYPASS = 'ACTIVITYPASS';
export const INVENTORY_VENUE_RESERVATIONS = 'VENUE_RESERVATIONS';
export const INVENTORY_TREE_PERMIT = 'TREE_PERMIT';
export const INVENTORY_RENTAL = 'RENTAL';
export const INVENTORY_LOTTERY_CAMPING = 'LOTTERY_CAMPING';
export const INVENTORY_QUEUE_LOTTERY = 'QUEUE_LOTTERY';
export const INVENTORY_DONATION = 'DONATION';
